import { FC } from "react";
import {
    Heading,
    Text,
    Button,
    Flex,
    Icon,
    Box,
} from "@smile2impress/components/relaunch";
import { useGoToBooking } from "hooks/useGoToBooking";

import getIcon from "utils/getIcon";
import Link from "components/Link";

import { TextWithCTAFiftyFiftyProps } from "./TextWithCTAFiftyFifty.types";

export const TextWithCTAFiftyFifty: FC<TextWithCTAFiftyFiftyProps> = ({
    content,
    headingAs,
}) => {
    const {
        title,
        text,
        cta,
        icon,
        bgColor = "base.grey",
        textColor = "text.base",
    } = content;
    const { goToBooking } = useGoToBooking();
    if (!cta.onClick && !cta.link) {
        cta.onClick = goToBooking;
    }
    const {
        text: buttonText,
        onClick,
        link,
        variant = "red",
        iconRight,
        iconLeft,
    } = cta;

    return (
        <Box px={[0, 0, 4]} as="section">
            <Flex
                rowGap={2}
                direction={["column", "column", "row"]}
                justifyContent="space-between"
                alignItems={["stretch", "stretch", "flex-end"]}
                bgColor={bgColor}
                borderRadius="sm"
                columnGap={[1, 1, 4]}
                p={[2, 2, 3]}
            >
                <Flex
                    direction={"column"}
                    rowGap={[1, 1, 2]}
                    flexBasis={["100%", "100%", "50%"]}
                >
                    {icon && (
                        <Flex>
                            <Icon
                                w={3}
                                h={3}
                                as={getIcon(icon)}
                                color="base.bitterSweet"
                            />
                        </Flex>
                    )}
                    {title && (
                        <Heading
                            textStyle={["H3"]}
                            color={[textColor]}
                            as={headingAs}
                            textTransform="uppercase"
                        >
                            {title}
                        </Heading>
                    )}
                    <Text
                        textAlign={["left"]}
                        textStyle={title ? "body" : "title3"}
                        color={[textColor]}
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                </Flex>
                <Flex flexBasis={["100%", "100%", "50%"]}>
                    <Button
                        as={Link}
                        {...(onClick ? { onClick } : {})}
                        {...(link ? { href: link } : {})}
                        width="100%"
                        h={3}
                        variant={variant}
                    >
                        {iconLeft && (
                            <Icon
                                w={1}
                                h={1}
                                as={getIcon(iconLeft)}
                                verticalAlign="baseline"
                                mr="8px"
                                marginBottom="-2px"
                            />
                        )}
                        {buttonText}
                        {iconRight && (
                            <Icon
                                w={1}
                                h={1}
                                as={getIcon(iconRight)}
                                verticalAlign="baseline"
                                ml="8px"
                                marginBottom="-2px"
                            />
                        )}
                    </Button>
                </Flex>
            </Flex>
        </Box>
    );
};
